module.exports = __webpack_public_path__ + "img/10n.dcd04298.svg";